<template>
  <div class="container">
    <h3>Coller le tableau depuis Excel</h3>
    <textarea
      v-model="pepites"
      type="textarea"
      class="form-control"
      placeholder="Copier ici les deux colonnes dans l'ordre : pseudo, ticker"
      rows="10"
    />

    <div class="my-3">
      <div class="text-left">
        <base-switch v-model="rush">
          <i class="tim-icons icon-check-2" slot="on"></i>
          <i class="tim-icons icon-simple-remove" slot="off"></i>
        </base-switch>
        <span class="ml-3 align-top">Mode RUSH</span>
      </div>
      <button
        type="button"
        @click="processPepites()"
        class="btn btn-info btn-outline"
      >
        Récupérer les cours
      </button>
      <button
        type="button"
        @click="downloadPepites()"
        class="btn btn-info btn-outline mx-3"
      >
        Télécharger les résultats
      </button>
      <span class="ml-4 text-primary">{{ currentState }}</span>
    </div>
    <div class="my-3 text-danger" v-if="symbolsNotFound.length">
      Tickers non trouvés : {{ symbolsNotFound.join(", ") }}
    </div>

    <base-table
      v-if="result.length > 0"
      :data="result"
      thead-classes="text-primary"
    >
      <template slot="columns" slot-scope="{ columns }">
        <th>Pseudo</th>
        <th>Ticker</th>
        <th>{{ rush ? "Close" : "Today" }}</th>
        <th>{{ rush ? "Open 16h" : "Monday" }}</th>
        <th>Percent</th>
      </template>
      <template slot-scope="{ row }">
        <td>{{ row[0] }}</td>
        <td>{{ row[1] }}</td>
        <td>{{ row[2] ? row[2].toLocaleString() : "" }}</td>
        <td>{{ row[3] ? row[3].toLocaleString() : "" }}</td>
        <td>{{ row[4] ? row[4].toLocaleString() : "" }}</td>
      </template>
    </base-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { BaseTable, BaseSwitch } from "@/components";
import { exportCSVFile } from "../../util/csvUtil";
import firebase from "@firebase/app";
const intraday = firebase.functions().httpsCallable("intraday");

export default {
  components: {
    BaseTable,
    BaseSwitch
  },
  data() {
    return {
      rush: false,
      pepites: "",
      result: [],
      currentState: "",
      symbolsNotFound: []
    };
  },
  computed: {
    ...mapGetters({
      livelist: "instruments/livelist"
    })
  },
  methods: {
    async downloadPepites() {
      await this.processPepites();
      console.log(this.result);
      const csv =
        (this.rush
          ? "Pseudo;Ticker;Close;Open 16h;Percent\r\n"
          : "Pseudo;Ticker;Today;Monday;Percent\r\n") +
        this.result
          .map(x => {
            return (
              x[0] +
              ";" +
              x[1] +
              ";" +
              (+x[2]).toString().replace(".", ",") +
              ";" +
              (+x[3]).toString().replace(".", ",") +
              ";" +
              (+x[4]).toString().replace(".", ",") +
              "\r\n"
            );
          })
          .join("");
      console.log(csv);
      exportCSVFile(csv, "pepitor");
    },
    mapSymbol(i) {
      if (i.id.indexOf(".") !== -1) return i.id;
      const eodCode =
        i.ty === "index"
          ? "INDX"
          : i.mk === "ETFP"
          ? "PA"
          : i.mk === "MTAA"
          ? "MI"
          : i.mk === "TNLB"
          ? "PA"
          : i.mk === "XAIM"
          ? "MI"
          : i.mk === "XAMS"
          ? "AS"
          : i.mk === "XBRU"
          ? "BR"
          : i.mk === "XDUB"
          ? "IR"
          : i.mk === "XETR"
          ? "XETRA"
          : i.mk === "XHEL"
          ? "HE"
          : i.mk === "XLIS"
          ? "LS"
          : i.mk === "XLON"
          ? "LSE"
          : i.mk === "XLUX"
          ? "LU"
          : i.mk === "XMAD"
          ? "MC"
          : i.mk === "XPAR"
          ? "PA"
          : i.mk === "XWBO"
          ? "VI"
          : "NA";
      return i.sy + "." + eodCode;
    },
    async processPepites() {
      this.result = [];
      this.symbolsNotFound = [];
      const unsorted = await Promise.all(
        this.pepites
          .split("\n")
          .map(p => p.split("\t"))
          .map(async p => {
            if (p.length != 2) return p;
            const l = this.livelist.find(l => l.sy === p[1].toUpperCase());
            if (!this.rush && l && l.in && l.in.hi && l.in.hi[8]) {
              let monday = l.in.hi[8];
              if (new Date().getDay() == 1) {
                monday = l.li.o;
              }
              const n = p.slice();
              const last = l.li.last;
              n.push(last);
              n.push(monday);
              n.push(((last - monday) / monday) * 100.0);
              return n;
            } else if (this.rush && l) {
              const today = new Date();
              const from =
                +new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  today.getDate(),
                  15,
                  55,
                  0
                ) / 1000;
              const to =
                +new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  today.getDate(),
                  18,
                  0,
                  0
                ) / 1000;
              console.log(from, to);
              const result = await intraday({
                ticker: this.mapSymbol(l),
                from,
                to
              });
              console.log(result);
              const n = p.slice();
              const last = l.li.last;
              n.push(last);
              n.push(result.data.quotes[0].o);
              n.push(
                ((last - result.data.quotes[0].o) / result.data.quotes[0].o) *
                  100.0
              );
              console.log(n);
              return n;
            } else {
              this.symbolsNotFound.push(p[1].toUpperCase());
              return p;
            }
          })
      );
      this.result = unsorted.sort((a, b) => {
        if (a[4] && b[4]) {
          return b[4] - a[4];
        }
        return -1;
      });
      console.log(this.result);
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
